// Imports Angular:
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule, NO_ERRORS_SCHEMA, LOCALE_ID } from '@angular/core';
import { FormsModule } from '@angular/forms';

// Imports externos:
import { ChartsModule } from 'ng2-charts';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { NgxBarcodeModule } from 'ngx-barcode';

// Imports Pipe's:
import { DomseguroPipe } from './pipes/domseguro.pipe';
import { NoimagesPipe } from './pipes/noimages.pipe';
import { NombreAbreviadoPipe } from './pipes/nombre-abreviado.pipe';
import { DomsegurohtmlPipe } from './pipes/domsegurohtml.pipe';
import { DatePipe } from '@angular/common';

// Import's idioma DatePicker:
import { defineLocale } from 'ngx-bootstrap/chronos';
import { esLocale } from 'ngx-bootstrap/locale';
defineLocale('es', esLocale);

// Import's idioma proyecto:
import localeEs from '@angular/common/locales/es';
import { registerLocaleData } from '@angular/common';
registerLocaleData(localeEs);

// Import PrimeNG
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MultiSelectModule } from 'primeng/multiselect';
import { DropdownModule } from 'primeng/dropdown';
import { QRCodeModule } from 'angularx-qrcode';
import { RadioButtonModule } from 'primeng/radiobutton';
import { ToastModule } from 'primeng/toast';

// Imports routes:
import { ROUTES_MAIN } from './app.routes';

// Imports Components:
import { AppComponent } from './app.component';
import { PageNotFoundComponent } from './components/shared/pages-errors/page-not-found/page-not-found.component';
import { PageInternalServerErrorComponent } from './components/shared/pages-errors/page-internal-server-error/page-internal-server-error.component';
import { ReporteAnalisisHabilidadComponent } from './components/reporte-analisis-habilidad/reporte-analisis-habilidad.component';
import { HeaderComponent } from './components/reporte-analisis-habilidad/header/header.component';
import { BodyComponent } from './components/reporte-analisis-habilidad/body/body.component';
import { GraficaRadarComponent } from './components/shared/graficas/grafica-radar/grafica-radar.component';
import { GraficaBarComponent } from './components/shared/graficas/grafica-bar/grafica-bar.component';
import { FooterComponent } from './components/shared/footer/footer.component';
import { NavbarComponent } from './components/shared/navbar/navbar.component';
import { ReporteCertificadoOcupacionalComponent } from './components/reporte-certificado-ocupacional/reporte-certificado-ocupacional.component';
import { HeaderCertificadoComponent } from './components/reporte-certificado-ocupacional/header-certificado/header-certificado.component';
import { SectionCertificadoComponent } from './components/reporte-certificado-ocupacional/body/section-certificado/section-certificado.component';
import { SectionValoracionComponent } from './components/reporte-certificado-ocupacional/body/section-valoracion/section-valoracion.component';
import { SectionColaboradorComponent } from './components/reporte-certificado-ocupacional/body/section-colaborador/section-colaborador.component';
import { SectionCumplimientoComponent } from './components/reporte-certificado-ocupacional/body/section-cumplimiento/section-cumplimiento.component';
import { SectionConceptoComponent } from './components/reporte-certificado-ocupacional/body/section-concepto/section-concepto.component';
import { SectionFirmasComponent } from './components/reporte-certificado-ocupacional/body/section-firmas/section-firmas.component';
import { FooterCertificadoComponent } from './components/reporte-certificado-ocupacional/footer-certificado/footer-certificado.component';
import { ReporteSomaComponent } from './components/reporte-soma/reporte-soma.component';
import { BodySomaComponent } from './components/reporte-soma/body-soma/body-soma.component';
import { HeaderConsolidadoLaboratorioComponent } from './components/reporte-consolidado-laboratorio/header-consolidado-laboratorio/header-consolidado-laboratorio.component';
import { ReporteConsolidadoLaboratorioComponent } from './components/reporte-consolidado-laboratorio/reporte-consolidado-laboratorio.component';
import { HeaderSomaComponent } from './components/reporte-soma/header-soma/header-soma.component';
import { HistoriaCenpresabilComponent } from './components/historia-cenpresabil/historia-cenpresabil.component';
import { HeaderHistoriaCenpresabilComponent } from './components/historia-cenpresabil/header-historia-cenpresabil/header-historia-cenpresabil.component';
import { FooterHistoriaCenpresabilComponent } from './components/historia-cenpresabil/footer-historia-cenpresabil/footer-historia-cenpresabil.component';
import { ReporteCitasLaboratorioComponent } from './components/reporte-citas-laboratorio/reporte-citas-laboratorio.component';
import { HeaderCitasLaboratorioComponent } from './components/reporte-citas-laboratorio/header-citas-laboratorio/header-citas-laboratorio.component';
import { HeaderInconformidadAgendaComponent } from './components/reporte-inconformidad-agenda/header-inconformidad-agenda/header-inconformidad-agenda.component';
import { ReporteInconformidadAgendaComponent } from './components/reporte-inconformidad-agenda/reporte-inconformidad-agenda.component';
import { ReporteControlDietaComponent } from './components/reportes-admisiones/procesos-admisiones/reporte-control-dieta/reporte-control-dieta.component';
import { ReporteOrdenesSinAgendaComponent } from './components/reporte-ordenes-sin-agenda/reporte-ordenes-sin-agenda.component';
import { HeaderOrdenesSinAgendaComponent } from './components/reporte-ordenes-sin-agenda/header-ordenes-sin-agenda/header-ordenes-sin-agenda.component';
import { ReporteComfenalcoComponent } from './components/reporte-comfenalco/reporte-comfenalco.component';
import { BodyComfenalcoComponent } from './components/reporte-comfenalco/body-comfenalco/body-comfenalco.component';
import { HeaderComfenalcoComponent } from './components/reporte-comfenalco/header-comfenalco/header-comfenalco.component';
import { ReporteResolucion1552Component } from './components/reporte-resolucion1552/reporte-resolucion1552.component';
import { HeaderResolucion1552Component } from './components/reporte-resolucion1552/header-resolucion1552/header-resolucion1552.component';
import { ReportePulseraComponent } from './components/reporte-pulsera/reporte-pulsera.component';
import { ReporteResolucion0256Component } from './components/reporte-resolucion0256/reporte-resolucion0256.component';
import { HeaderResolucion0256Component } from './components/reporte-resolucion0256/header-resolucion0256/header-resolucion0256.component';
import { ReporteNotasEnfermeriaComponent } from './components/reporte-notas-enfermeria/reporte-notas-enfermeria.component';
import { HeaderNotasEnfermeriaComponent } from './components/reporte-notas-enfermeria/header-notas-enfermeria/header-notas-enfermeria.component';
import { ReporteFormatoPagareComponent } from './components/reporte-formato-pagare/reporte-formato-pagare.component';
import { HeaderFormatoPagareComponent } from './components/reporte-formato-pagare/header-formato-pagare/header-formato-pagare.component';
import { ReporteSolicitudesSuministrosComponent } from './components/reporte-solicitudes-suministros/reporte-solicitudes-suministros.component';
import { HeaderSolicitudesSuministrosComponent } from './components/reporte-solicitudes-suministros/header-solicitudes-suministros/header-solicitudes-suministros.component';
import { ReporteImprimirAdmisionComponent } from './components/reportes-admisiones/procesos-admisiones/reporte-imprimir-admision/reporte-imprimir-admision.component';
import {
  HeaderImprimirAdmisionComponent
} from './components/reportes-admisiones/procesos-admisiones/reporte-imprimir-admision/header-imprimir-admision/header-imprimir-admision.component';

import {
  ReporteProcedimientosAdmisionesComponent
} from './components/reportes-admisiones/procesos-admisiones/reporte-procedimientos-admisiones/reporte-procedimientos-admisiones.component';

import {
  HeaderProcedimientosAdmisionComponent
} from './components/reportes-admisiones/procesos-admisiones/reporte-procedimientos-admisiones/header-procedimientos-admision/header-procedimientos-admision.component';

import {
  ReporteMedicamentosHomologadosComponent
} from './components/reportes-admisiones/procesos-admisiones/reporte-medicamentos-homologados/reporte-medicamentos-homologados.component';

import {
  ReporteRegistroMedicamentosInsumosComponent
} from './components/reportes-admisiones/procesos-admisiones/reporte-registro-medicamentos-insumos/reporte-registro-medicamentos-insumos.component';

import { ReporteOrdenesMedicasComponent } from './components/reportes-admisiones/procesos-admisiones/reporte-ordenes-medicas/reporte-ordenes-medicas.component';

import {
  ReporteSolicitudPendienteMedicamentosComponent
} from './components/reportes-admisiones/procesos-admisiones/reporte-solicitud-pendiente-medicamentos/reporte-solicitud-pendiente-medicamentos.component';

import { HeaderControlDietaComponent } from './components/reportes-admisiones/procesos-admisiones/reporte-control-dieta/header-control-dieta/header-control-dieta.component';
import { ReporteOrdenAdmisionComponent } from './components/reportes-admisiones/procesos-admisiones/reporte-orden-admision/reporte-orden-admision.component';
import { HeaderOrdenAdmisionComponent } from './components/reportes-admisiones/procesos-admisiones/reporte-orden-admision/header-orden-admision/header-orden-admision.component';
import { LoadingComponent } from './components/shared/loading/loading.component';
import { ReporteAltaVoluntariaComponent } from './components/reportes-admisiones/procesos-admisiones/reporte-alta-voluntaria/reporte-alta-voluntaria.component';
import { ReporteRecordatorioCitasComponent } from './components/reportes-citas/reporte-recordatorio-citas/reporte-recordatorio-citas.component';
import { ReporteRecordatorioCitasSComponent } from './components/reportes-citas/reporte-recordatorio-citas-s/reporte-recordatorio-citas-s.component';
import { ReporteFacturaVentaComponent } from './components/reportes-facturacion/reporte-factura-venta/reporte-factura-venta.component';
// tslint:disable-next-line: max-line-length
import { ReporteOrdenSuministroAdmisionComponent } from './components/reportes-admisiones/procesos-admisiones/reporte-orden-suministro-admision/reporte-orden-suministro-admision.component';
// tslint:disable-next-line: max-line-length
import { HeaderOrdenSuministroAdmisionComponent } from './components/reportes-admisiones/procesos-admisiones/reporte-orden-suministro-admision/header-orden-suministro-admision/header-orden-suministro-admision.component';
// tslint:disable-next-line: max-line-length
import { HeaderNotificacionDevolucionMedicamentosComponent } from './components/reporte-notificacion-devolucion-medicamentos/header-notificacion-devolucion-medicamentos/header-notificacion-devolucion-medicamentos.component';
// tslint:disable-next-line: max-line-length
import { ReporteNotificacionDevolucionMedicamentosComponent } from './components/reporte-notificacion-devolucion-medicamentos/reporte-notificacion-devolucion-medicamentos.component';
import { ReporteFormatoAsistencialComponent } from './components/reporte-formato-asistencial/reporte-formato-asistencial.component';
import { HeaderFormatoAsistencialComponent } from './components/reporte-formato-asistencial/header-formato-asistencial/header-formato-asistencial.component';
import { EncabezadoFormatoComponent } from './components/reporte-formato-asistencial/encabezado-formato/encabezado-formato.component';
import { FirmasFormatoComponent } from './components/reporte-formato-asistencial/firmas-formato/firmas-formato.component';
import { CuerpoFormatoComponent } from './components/reporte-formato-asistencial/cuerpo-formato/cuerpo-formato.component';
import { CuadroTextoComponent } from './components/reporte-formato-asistencial/componentes/cuadro-texto/cuadro-texto.component';
import { FilaComponent } from './components/reporte-formato-asistencial/componentes/fila/fila.component';
import { ColumnaComponent } from './components/reporte-formato-asistencial/componentes/columna/columna.component';
import { ListaDesplegableComponent } from './components/reporte-formato-asistencial/componentes/lista-desplegable/lista-desplegable.component';
import { FechaComponent } from './components/reporte-formato-asistencial/componentes/fecha/fecha.component';
import { MatrizComponent } from './components/reporte-formato-asistencial/componentes/matriz/matriz.component';
import { TablaComponent } from './components/reporte-formato-asistencial/componentes/tabla/tabla.component';
import { SeleccionUnicaComponent } from './components/reporte-formato-asistencial/componentes/seleccion-unica/seleccion-unica.component';
import { Cie10Component } from './components/reporte-formato-asistencial/componentes/cie10/cie10.component';
import { AcordionComponent } from './components/reporte-formato-asistencial/componentes/acordion/acordion.component';
import { AcordionTabComponent } from './components/reporte-formato-asistencial/componentes/acordion/acordion-tab/acordion-tab.component';
import { LabelComponent } from './components/reporte-formato-asistencial/componentes/label/label.component';
import { CasillaVerificacionComponent } from './components/reporte-formato-asistencial/componentes/casilla-verificacion/casilla-verificacion.component';
import { SignosVitalesComponent } from './components/reporte-formato-asistencial/componentes/signos-vitales/signos-vitales.component';
import { TablaDxComponent } from './components/reporte-formato-asistencial/componentes/tabla-dx/tabla-dx.component';
import { FormulaComponent } from './components/reporte-formato-asistencial/componentes/formula/formula.component';
import { CondicionComponent } from './components/reporte-formato-asistencial/componentes/condicion/condicion.component';
import { DiagnosticoComponent } from './components/reporte-formato-asistencial/componentes/diagnostico/diagnostico.component';
import { EditorComponent } from './components/reporte-formato-asistencial/componentes/editor/editor.component';
import { AyudasDiagnosticasComponent } from './components/reporte-formato-asistencial/componentes/ayudas-diagnosticas/ayudas-diagnosticas.component';
import { NotasComponent } from './components/reporte-formato-asistencial/componentes/notas/notas.component';
import { EvolucionesComponent } from './components/reporte-formato-asistencial/componentes/evoluciones/evoluciones.component';
import { EvolucionComponent } from './components/reporte-formato-asistencial/componentes/evolucion/evolucion.component';
import { EncabezadoEvoComponent } from './components/reporte-formato-asistencial/componentes/evolucion/encabezado-evo/encabezado-evo.component';
import { ReporteComprobanteInformeDiarioDianComponent } from './components/reporte-comprobante-informe-diario-dian/reporte-comprobante-informe-diario-dian.component';
import { HeaderComprobanteInformeComponent } from './components/reporte-comprobante-informe-diario-dian/header-comprobante-informe/header-comprobante-informe.component';
import { LoadingInfoComponent } from './components/shared/loading-info/loading-info.component';
import { ComprobanteInformeDiarioResumidoComponent } from './components/reporte-comprobante-informe-diario-dian/comprobante-informe-diario-resumido/comprobante-informe-diario-resumido.component';
import { AlertComponent } from './components/shared/alert/alert.component';
import { AudiometriaTonalComponent } from './components/reporte-formato-asistencial/componentes/audiometria-tonal/audiometria-tonal.component';
import { AudiometriaVocalComponent } from './components/reporte-formato-asistencial/componentes/audiometria-vocal/audiometria-vocal.component';
import { PanelComponent } from './components/reporte-formato-asistencial/componentes/panel/panel.component';
import { OdontogramaComponent } from './components/reporte-formato-asistencial/componentes/odontograma/odontograma.component';
import { DermatomasComponent } from './components/reporte-formato-asistencial/componentes/dermatomas/dermatomas.component';
import { ReporteAnticipoComponent } from './components/reporte-anticipo/reporte-anticipo.component';
import { ReporteAnexoIIComponent } from './components/reporte-anexo-ii/reporte-anexo-ii.component';
import { ReporteCuentaCobroDomicilioComponent } from './components/reporte-cuenta-cobro-domicilio/reporte-cuenta-cobro-domicilio.component';
import { HeaderCuentaCobroDomicilioComponent } from './components/reporte-cuenta-cobro-domicilio/header-cuenta-cobro-domicilio/header-cuenta-cobro-domicilio.component';
import { ReporteAdmision2Component } from './components/reportes-admisiones/procesos-admisiones/reporte-admision2/reporte-admision2.component';
import { HeaderAdmision2Component } from './components/reportes-admisiones/procesos-admisiones/reporte-admision2/header-admision2/header-admision2.component';
import { LoginComponent } from './components/login/login.component';
import { AuthInterceptorService } from './services/utils/auth-interceptor.service';
import { PageTokenInvalidateComponent } from './components/shared/pages-errors/page-token-invalidate/page-token-invalidate.component';
import { ReporteEncuestaCovidComponent } from './components/reporte-encuesta-covid/reporte-encuesta-covid.component';
import { HeaderEncuestaCovidComponent } from './components/reporte-encuesta-covid/header-encuesta-covid/header-encuesta-covid.component';
import { AreaTextoComponent } from './components/reporte-encuesta-covid/componentes/area-texto/area-texto.component';
import { GrupoPreguntaComponent } from './components/reporte-encuesta-covid/componentes/grupo-pregunta/grupo-pregunta.component';
import { PreguntaComponent } from './components/reporte-encuesta-covid/componentes/pregunta/pregunta.component';
import { SeleccionUnicaComponent as CovidSeleccionUnicaComponent } from './components/reporte-encuesta-covid/componentes/seleccion-unica/seleccion-unica.component';
import { ListaDesplegableComponent as CovidListaDesplegableComponent } from './components/reporte-encuesta-covid/componentes/lista-desplegable/lista-desplegable.component';
import { ReporteAdmisionesAbiertasComponent } from './components/reportes-admisiones/reporte-admisiones-abiertas/reporte-admisiones-abiertas.component';
import { HeaderAdmisionesAbiertasComponent } from './components/reportes-admisiones/reporte-admisiones-abiertas/header-admisiones-abiertas/header-admisiones-abiertas.component';
import { ReporteEpicrisisComponent } from './components/reporte-epicrisis/reporte-epicrisis.component';
import { HeaderEpicrisisComponent } from './components/reporte-epicrisis/header-epicrisis/header-epicrisis.component';
import { ReporteAdmisionesAbiertasCreacionComponent } from './components/reportes-admisiones/reporte-admisiones-abiertas-creacion/reporte-admisiones-abiertas-creacion.component';
import { HeaderAdmisionesAbiertasCreacionComponent } from './components/reportes-admisiones/reporte-admisiones-abiertas-creacion/header-admisiones-abiertas-creacion/header-admisiones-abiertas-creacion.component';
import { NodoService } from './services/utils/nodo.service';
import { MatrizAgrupamientoComponent } from './components/reporte-formato-asistencial/componentes/matriz-agrupamiento/matriz-agrupamiento.component';
import { ReporteRibisoftComponent } from './components/reportes-facturacion/reporte-ribisoft/reporte-ribisoft.component';
import { HeaderReporteRibisoftComponent } from './components/reportes-facturacion/reporte-ribisoft/header-reporte-ribisoft/header-reporte-ribisoft.component';
import { HeaderFormulasMedicasComponent } from './components/reportes-solicitud-servicios/reporte-formulas-medicas/header-formulas-medicas/header-formulas-medicas.component';
// tslint:disable-next-line:max-line-length
import { FormulasMedicasEvolucionesComponent } from './components/reportes-solicitud-servicios/reporte-formulas-medicas/formulas-medicas-evoluciones/formulas-medicas-evoluciones.component';
import { FormulasMedicasHcComponent } from './components/reportes-solicitud-servicios/reporte-formulas-medicas/formulas-medicas-hc/formulas-medicas-hc.component';
import { ReporteOrdenMedicaComponent } from './components/reportes-solicitud-servicios/reporte-orden-medica/reporte-orden-medica.component';
import { HeaderOrdenMedicaComponent } from './components/reportes-solicitud-servicios/reporte-orden-medica/header-orden-medica/header-orden-medica.component';
import { HeaderOrdenEscritasComponent } from './components/reportes-ordenamientos/reporte-orden-escritas/header-orden-escritas/header-orden-escritas.component';
import { ReporteOrdenEscritasComponent } from './components/reportes-ordenamientos/reporte-orden-escritas/reporte-orden-escritas.component';
import { ReporteOrdenServiciosComponent } from './components/reportes-ordenamientos/reporte-orden-servicios/reporte-orden-servicios.component';
import { HeaderOrdenServiciosComponent } from './components/reportes-ordenamientos/reporte-orden-servicios/header-orden-servicios/header-orden-servicios.component';
import { ReporteOrdenMedicamentosComponent } from './components/reportes-ordenamientos/reporte-orden-medicamentos/reporte-orden-medicamentos.component';
import { HeaderOrdenMedicamentosComponent } from './components/reportes-ordenamientos/reporte-orden-medicamentos/header-orden-medicamentos/header-orden-medicamentos.component';
import { ReporteOrdenGeneralComponent } from './components/reportes-ordenamientos/reporte-orden-general/reporte-orden-general.component';
import { HeaderOrdenGeneralComponent } from './components/reportes-ordenamientos/reporte-orden-general/header-orden-general/header-orden-general.component';
import { MessageService } from 'primeng/api';
import { PreguntaAsistencialComponent } from './components/reporte-formato-asistencial/pregunta-asistencial/pregunta-asistencial.component';
import { CuerpoPreguntaAsistencialComponent } from './components/reporte-formato-asistencial/cuerpo-pregunta-asistencial/cuerpo-pregunta-asistencial.component';
import { ReporteIntegracionHcComponent } from './components/reporte-integracion-hc/reporte-integracion-hc.component';
import { HeaderIntegracionHcComponent } from './components/reporte-integracion-hc/header-integracion-hc/header-integracion-hc.component';
import { ReporteCaptacionComponent } from './components/reporte-captacion/reporte-captacion.component';
import { HeaderCaptacionComponent } from './components/reporte-captacion/header-captacion/header-captacion.component';
import { ReporteCarteraPacientesComponent} from './components/reporte-cartera-pacientes/reporte-cartera-pacientes.component';
import { HeaderCarteraPacientesComponent } from './components/reporte-cartera-pacientes/header-cartera-pacientes/header-cartera-pacientes.component';
import { ReporteRecordatorioCitasPosComponent } from './components/reportes-citas/reporte-recordatorio-citas-pos/reporte-recordatorio-citas-pos.component';
import { ReporteEntregaMedicamentosComponent } from './components/reportes-facturacion/reporte-entrega-medicamentos/reporte-entrega-medicamentos.component';
import { HeaderEntregaMedicamentosComponent } from './components/reportes-facturacion/reporte-entrega-medicamentos/header-orden-escritas/header-entrega-medicamentos.component';
import { DialogModule } from 'primeng/dialog';
import { AdmisionComponent } from './components/reporte-formato-asistencial/admision/admision.component';
import { HeaderAdmisionComponent } from './components/reporte-formato-asistencial/admision/header-admision/header-admision.component';
import { AreaComponent } from './components/reporte-formato-asistencial/componentes/area/area.component';
import { FechaHoraComponent } from './components/reporte-formato-asistencial/componentes/fecha-hora/fecha-hora.component';
import { HeaderOrdenMedicamentosControladosComponent} from './components/reportes-ordenamientos/reporte-orden-medicamentos-controlados/header-orden-medicamentos-controlados/header-orden-medicamentos-controlados.component';
import { ReporteOrdenMedicamentosControladosComponent} from './components/reportes-ordenamientos/reporte-orden-medicamentos-controlados/reporte-orden-medicamentos-controlados.component';
import { ReporteHistoriaComponent } from './components/reporte-historia/reporte-historia.component';
import { FiltrosComponent } from './components/reporte-historia/filtros/filtros.component';
import { ReporteIncapacidadComponent } from './components/reporte-incapacidad/reporte-incapacidad.component';
import { HeaderIncapacidadComponent } from './components/reporte-incapacidad/header-incapacidad/header-incapacidad.component';
import { FiltrosComponent as FiltrosHistoriaComponent } from './components/reporte-historia/filtros/filtros.component';
import { ReporteEvolucionComponent } from './components/reporte-evolucion/reporte-evolucion.component';
import { FiltrosComponent as FiltrosEvolucionComponent } from './components/reporte-evolucion/filtros/filtros.component';
import { EncabezadoIncapacidadComponent } from './components/reporte-incapacidad/encabezado-incapacidad/encabezado-incapacidad.component';
import { ReporteDemandaInducidaComponent } from './components/reporte-demanda-inducida/reporte-demanda-inducida.component';
import { HeaderDemandaInducidaComponent } from './components/reporte-demanda-inducida/header-demanda-inducida/header-demanda-inducida.component';
import { ReportePreguntaComponent } from './components/reporte-pregunta/reporte-pregunta.component';
import { FiltrosComponent as FiltrosPreguntaComponent} from './components/reporte-pregunta/filtros/filtros.component';
import { RelacionAdmisionesComponent } from './components/reportes-admisiones/relacion-admisiones/relacion-admisiones.component';
import { MovimientoPacienteByRangoFechaComponent } from './components/reportes-admisiones/movimiento-paciente-by-rango-fecha/movimiento-paciente-by-rango-fecha.component';
// @ts-ignore
import { HeaderMovimientoPacienteByRangoFechaComponent } from './components/reportes-admisiones/movimiento-paciente-by-rango-fecha/header-movimiento-paciente-by-rango-fecha/header-movimiento-paciente-by-rango-fecha.component';
// @ts-ignore
import {HeaderRelacionAdmisionesComponent} from './components/reportes-admisiones/relacion-admisiones/header-relacion-admisiones/header-relacion-admisiones.component';
import { ReporteIncapacidad1427Component } from './components/reporte-incapacidad1427/reporte-incapacidad1427.component';
import { ReporteInteropereabilidadHcComponent } from './components/reporte-interopereabilidad-hc/reporte-interopereabilidad-hc.component';
import { ConsultaInformacionComponent } from './components/reporte-interopereabilidad-hc/consulta-informacion/consulta-informacion.component';


@NgModule({
  declarations: [
    AppComponent,
    DomseguroPipe,
    NoimagesPipe,
    PageNotFoundComponent,
    PageInternalServerErrorComponent,
    ReporteAnalisisHabilidadComponent,
    HeaderComponent,
    BodyComponent,
    GraficaRadarComponent,
    GraficaBarComponent,
    FooterComponent,
    NavbarComponent,
    ReporteCertificadoOcupacionalComponent,
    HeaderCertificadoComponent,
    SectionCertificadoComponent,
    SectionValoracionComponent,
    SectionColaboradorComponent,
    SectionCumplimientoComponent,
    SectionConceptoComponent,
    SectionFirmasComponent,
    FooterCertificadoComponent,
    ReporteConsolidadoLaboratorioComponent,
    HeaderConsolidadoLaboratorioComponent,
    ReporteSomaComponent,
    BodySomaComponent,
    HeaderSomaComponent,
    HistoriaCenpresabilComponent,
    HeaderHistoriaCenpresabilComponent,
    FooterHistoriaCenpresabilComponent,
    NombreAbreviadoPipe,
    DomsegurohtmlPipe,
    ReporteCitasLaboratorioComponent,
    HeaderCitasLaboratorioComponent,
    HeaderInconformidadAgendaComponent,
    ReporteInconformidadAgendaComponent,
    ReporteOrdenesSinAgendaComponent,
    HeaderOrdenesSinAgendaComponent,
    ReporteComfenalcoComponent,
    BodyComfenalcoComponent,
    HeaderComfenalcoComponent,
    ReporteResolucion1552Component,
    HeaderResolucion1552Component,
    ReportePulseraComponent,
    ReporteResolucion0256Component,
    HeaderResolucion0256Component,
    ReporteNotasEnfermeriaComponent,
    HeaderNotasEnfermeriaComponent,
    ReporteFormatoPagareComponent,
    HeaderFormatoPagareComponent,
    ReporteSolicitudesSuministrosComponent,
    HeaderSolicitudesSuministrosComponent,
    ReporteImprimirAdmisionComponent,
    HeaderImprimirAdmisionComponent,
    ReporteProcedimientosAdmisionesComponent,
    ReporteRegistroMedicamentosInsumosComponent,
    HeaderProcedimientosAdmisionComponent,
    ReporteMedicamentosHomologadosComponent,
    ReporteOrdenesMedicasComponent,
    ReporteSolicitudPendienteMedicamentosComponent,
    ReporteControlDietaComponent,
    HeaderControlDietaComponent,
    ReporteOrdenAdmisionComponent,
    HeaderOrdenAdmisionComponent,
    LoadingComponent,
    ReporteAltaVoluntariaComponent,
    ReporteRecordatorioCitasComponent,
    ReporteRecordatorioCitasSComponent,
    ReporteFacturaVentaComponent,
    ReporteOrdenSuministroAdmisionComponent,
    HeaderOrdenSuministroAdmisionComponent,
    HeaderNotificacionDevolucionMedicamentosComponent,
    ReporteNotificacionDevolucionMedicamentosComponent,
    ReporteFormatoAsistencialComponent,
    HeaderFormatoAsistencialComponent,
    EncabezadoFormatoComponent,
    FirmasFormatoComponent,
    CuerpoFormatoComponent,
    CuadroTextoComponent,
    FilaComponent,
    ColumnaComponent,
    ListaDesplegableComponent,
    FechaComponent,
    MatrizComponent,
    TablaComponent,
    SeleccionUnicaComponent,
    Cie10Component,
    AcordionComponent,
    AcordionTabComponent,
    LabelComponent,
    CasillaVerificacionComponent,
    SignosVitalesComponent,
    TablaDxComponent,
    FormulaComponent,
    CondicionComponent,
    DiagnosticoComponent,
    EditorComponent,
    AyudasDiagnosticasComponent,
    NotasComponent,
    EvolucionesComponent,
    EvolucionComponent,
    EncabezadoEvoComponent,
    ReporteComprobanteInformeDiarioDianComponent,
    HeaderComprobanteInformeComponent,
    LoadingInfoComponent,
    ComprobanteInformeDiarioResumidoComponent,
    AlertComponent,
    AudiometriaTonalComponent,
    AudiometriaVocalComponent,
    PanelComponent,
    OdontogramaComponent,
    DermatomasComponent,
    ReporteAnticipoComponent,
    ReporteAnexoIIComponent,
    ReporteCuentaCobroDomicilioComponent,
    HeaderCuentaCobroDomicilioComponent,
    ReporteAdmision2Component,
    HeaderAdmision2Component,
    LoginComponent,
    PageTokenInvalidateComponent,
    ReporteEncuestaCovidComponent,
    HeaderEncuestaCovidComponent,
    AreaTextoComponent,
    GrupoPreguntaComponent,
    PreguntaComponent,
    CovidSeleccionUnicaComponent,
    CovidListaDesplegableComponent,
    ReporteAdmisionesAbiertasComponent,
    HeaderAdmisionesAbiertasComponent,
    ReporteEpicrisisComponent,
    HeaderEpicrisisComponent,
    ReporteAdmisionesAbiertasCreacionComponent,
    HeaderAdmisionesAbiertasCreacionComponent,
    MatrizAgrupamientoComponent,
    ReporteRibisoftComponent,
    HeaderReporteRibisoftComponent,
    HeaderFormulasMedicasComponent,
    FormulasMedicasEvolucionesComponent,
    FormulasMedicasHcComponent,
    ReporteOrdenMedicaComponent,
    HeaderOrdenMedicaComponent,
    ReporteOrdenEscritasComponent,
    HeaderOrdenEscritasComponent,
    ReporteOrdenServiciosComponent,
    HeaderOrdenServiciosComponent,
    ReporteOrdenMedicamentosComponent,
    HeaderOrdenMedicamentosComponent,
    ReporteOrdenGeneralComponent,
    HeaderOrdenGeneralComponent,
    PreguntaAsistencialComponent,
    CuerpoPreguntaAsistencialComponent,
    ReporteIntegracionHcComponent,
    HeaderIntegracionHcComponent,
    ReporteCaptacionComponent,
    HeaderCaptacionComponent,
    ReporteCarteraPacientesComponent,
    HeaderCarteraPacientesComponent,
    ReporteRecordatorioCitasPosComponent,
    ReporteEntregaMedicamentosComponent,
    HeaderEntregaMedicamentosComponent,
    AdmisionComponent,
    HeaderAdmisionComponent,
    AreaComponent,
    FechaHoraComponent,
    ReporteOrdenMedicamentosControladosComponent,
    HeaderOrdenMedicamentosControladosComponent,
    ReporteHistoriaComponent,
    FiltrosComponent,
    ReporteIncapacidadComponent,
    HeaderIncapacidadComponent,
    FiltrosHistoriaComponent,
    ReporteEvolucionComponent,
    FiltrosEvolucionComponent,
    EncabezadoIncapacidadComponent,
    ReporteDemandaInducidaComponent,
    HeaderDemandaInducidaComponent,
    ReportePreguntaComponent,
    FiltrosPreguntaComponent,
    RelacionAdmisionesComponent,
    MovimientoPacienteByRangoFechaComponent,
    HeaderMovimientoPacienteByRangoFechaComponent,
    HeaderRelacionAdmisionesComponent,
    ReporteIncapacidad1427Component,
    ReporteInteropereabilidadHcComponent,
    ConsultaInformacionComponent
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    ChartsModule,
    FormsModule,
    BsDatepickerModule.forRoot(),
    ROUTES_MAIN,
    BrowserAnimationsModule,
    QRCodeModule,
    MultiSelectModule,
    DropdownModule,
    RadioButtonModule,
    NgxBarcodeModule,
    ToastModule,
    DialogModule
  ],
  entryComponents: [
    FilaComponent, ColumnaComponent, ListaDesplegableComponent,
    CuadroTextoComponent, FechaComponent, MatrizComponent, TablaComponent,
    SeleccionUnicaComponent, Cie10Component, AcordionComponent,
    AcordionTabComponent, LabelComponent, CasillaVerificacionComponent,
    SignosVitalesComponent, TablaDxComponent, FormulaComponent,
    CondicionComponent, DiagnosticoComponent, EditorComponent,
    AyudasDiagnosticasComponent, NotasComponent, AudiometriaTonalComponent,
    AudiometriaVocalComponent, PanelComponent, OdontogramaComponent,
    DermatomasComponent, GrupoPreguntaComponent, PreguntaComponent,
    AreaTextoComponent, ListaDesplegableComponent, CovidSeleccionUnicaComponent,
    CovidListaDesplegableComponent, MatrizAgrupamientoComponent, AreaComponent, FechaHoraComponent
  ],
  providers: [
    { provide: LOCALE_ID, useValue: 'es' },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptorService,
      multi: true
    },
    DatePipe,
    NodoService,
    MessageService
  ],
  bootstrap: [AppComponent],
  schemas: [
    NO_ERRORS_SCHEMA
  ]
})
export class AppModule { }
